var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.6666 5.33334H5.33331C3.12398 5.33334 1.33331 7.12401 1.33331 9.33334V22.6667C1.33331 24.876 3.12398 26.6667 5.33331 26.6667H18.6666C20.876 26.6667 22.6666 24.876 22.6666 22.6667V9.33334C22.6666 7.12401 20.876 5.33334 18.6666 5.33334Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.192 8.28133C28.8147 8.09333 28.4067 8 28 8C27.4334 8 26.8707 8.18 26.4 8.53333L22.6667 11.3333V20.6667L26.4 23.4667C26.8707 23.82 27.4334 24 28 24C28.4067 24 28.8147 23.9067 29.192 23.7187C30.096 23.2667 30.6667 22.344 30.6667 21.3333V10.6667C30.6667 9.656 30.096 8.73333 29.192 8.28133Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9c2057b1daa9df2f9a48e15cc354d5ba.svg";
export { ForwardRef as ReactComponent };